import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const getUserProfile = (userId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ADMIN.USER_MANAGEMENT.GET_USER_PROFILE(userId)
  );
};

export default getUserProfile;
